import React from "react";
import {Header} from "../header/header";

export const BackGround = (props) => (
    <div className={"bg-pattern bg-cover bg-center bg-no-repeat w-screen h-screen"}>
        <Header/>
        {props.children}
    </div>
);